import {useNavigate} from 'react-router-dom';
import {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import {activity_palettes} from "../../themes";
import AnimationOverlay from "../../baseElements/AnimationOverlay";
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import {MediaPlayer, MediaProvider} from '@vidstack/react';
import {defaultLayoutIcons, DefaultVideoLayout} from '@vidstack/react/player/layouts/default';

import '../../css/GeneralActivitiesCSS/GeneralActivityDesktop.css'
import '../../css/GeneralActivitiesCSS/GeneralActivityTablet.css'
import '../../css/GeneralActivitiesCSS/GeneralActivityPhone.css'
import {AppContext} from "../../AppContext";
import {getExerciseFromDB, getVideo, redirectToExercise, updateCurrentLog} from "../../ActivityManager";
import FinishTutorialButton from "../../baseElements/FinishTutorialButton";
import TopBarTutorial from "../../baseElements/TopBarTutorial";

axios.defaults.withCredentials = true;

const BACKGROUND_STYLE = activity_palettes.green.primary;

function VideoTutorial() {
    
    const {activityList, setActivityList, currentActivity} = useContext(AppContext);
    
    const navigate = useNavigate();
    
    const [, setIsMdOrLess] = useState(window.innerWidth <= 768);
    const [, setIsAnimating] = useState(false);
    
    const [videoUrl, setVideoUrl] = useState('');
    const [exerciseLog, setExerciseLog] = useState({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    const [flowButtons, setFlowButtons] = useState({finishTutorial: true});
    
    const exerciseId = activityList[0][0];
    const exerciseType = activityList[0][1];
    
    
    function resetStates() {
        setIsAnimating(false);
        updateButtonFlow(true, false);
        setExerciseLog({exercise_id: 0, exercise_type: '', progress: 0, actions: []});
    }
    
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        
        window.onpopstate = (event) => {
            event.preventDefault();
            navigate('/home'); // Navigate directly to /home
        };
        
        return () => {
            window.onpopstate = null;
        };
    }, [navigate]);
    
    function updateButtonFlow(showFinishTutorial) {
        setFlowButtons({finishTutorial: showFinishTutorial});
    }
    
    const handleResize = () => {
        setIsMdOrLess(window.innerWidth < 768);
    };
    
    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    
    useEffect(() => {
        resetStates();
        loadExercise().then();
    }, [navigate]);
    
    async function loadExercise() {
        try {
            const exerciseResponse = await getExerciseFromDB(activityList);
            if (exerciseResponse.success) {
                const videoName = exerciseResponse.data[4]?.video_tutorial?.url;
                
                const videoResponse = await getVideo(videoName);
                
                if (videoResponse?.success) {
                    // Decode base64 data
                    const binaryString = atob(videoResponse.data); // Decodes base64 string
                    const len = binaryString.length;
                    const byteArray = new Uint8Array(len);
                    
                    // Convert binary string to Uint8Array
                    for (let i = 0; i < len; i++) {
                        byteArray[i] = binaryString.charCodeAt(i);
                    }
                    
                    // Create a Blob from the Uint8Array
                    const blob = new Blob([byteArray], { type: 'video/mp4' });
                    
                    // Generate a URL for the Blob and set it
                    const blobUrl = URL.createObjectURL(blob);
                    console.log('Generated Blob URL:', blobUrl);
                    setVideoUrl(blobUrl);
                } else {
                    console.error('Video fetch error:', videoResponse?.errorMess);
                }
            } else {
                console.error('Exercise fetch error:', exerciseResponse.errorMess);
            }
        } catch (error) {
            console.error('Error loading exercise:', error);
        }
    }
    
    function handleFinishClick() {
        logUserAction();
    }
    
    function logUserAction() {
        setExerciseLog((prev) => ({
            ...prev,
            exercise_id: exerciseId,
            exercise_type: exerciseType,
            progress: 100,
            actions: [],
        }));
    }
    
    useEffect(() => {
        if (exerciseLog.exercise_id !== 0) {
            updateCurrentLog(currentActivity, exerciseLog).then(() => {
                const temp = [...activityList];
                temp.shift();
                setActivityList(temp);
                redirectToExercise(temp, navigate);
            });
        }
    }, [exerciseLog]);
    
    useEffect(() => {
        if (videoUrl) {
            console.log('Generated Blob URL:', videoUrl);
        }
    }, [videoUrl]);
    
    
    return (
        <div className='generalActivitiesBackground custom-col-12 tablet-custom-col-12' style={{backgroundColor: BACKGROUND_STYLE}}>
            <AnimationOverlay isAnimating={false}></AnimationOverlay>
            <div className='generalActivitiesPageContent custom-col-11 tablet-custom-col-11'>
                <div className='generalActivitiesTopBarArea custom-row' style={{height: "10%"}}>
                    <TopBarTutorial></TopBarTutorial>
                </div>
                <div className='generalActivitiesGameElementsArea row' style={{height: '80%', width: '65%'}}>
                    <MediaPlayer title="Sprite Fight" src={{src: videoUrl, type: 'video/mp4'}}>
                        <MediaProvider />
                        <DefaultVideoLayout icons={defaultLayoutIcons} />
                    </MediaPlayer>
                
                </div>
                <div className='generalActivitiesConfirmButtonArea custom-row'>
                    {flowButtons.finishTutorial && <FinishTutorialButton onClick={handleFinishClick}/>}
                </div>
            </div>
        </div>
    )
        ;
}

export default VideoTutorial;
